<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <p class="body-1">
          In order to transfer a domain name to the GreenGeeks you will need to ensure that several required items
          and/or actions have been taken. Please ensure that you have all of the following required items and/or
          actions before you submit your domain transfer request.
        </p>
        <ol class="body-1">
          <li>Domain has been registered for at least 60 days (there is a domain lock whereby a domain name cannot
            be transferred until after 60 days of the original registration).
          </li>
          <li>Domain name is not expired or close to expiration date (expired domains or domains which are within 14
            days of their expiration cannot be transferred).
          </li>
          <li>Domain name has been unlocked (please contact the current registrar to do so).</li>
          <li>Domain’s name servers are already pointed to the GreenGeeks name servers.</li>
          <li>You have the domain name EPP – Domain authorization code (contact your current registrar to obtain
            this code).
          </li>
          <li>You are the administrative e-mail contact person on this domain name’s whois record (Whois privacy
            should be disabled).
          </li>
        </ol>
        <p class="pt-3 body-1">
          Once the above are completed, simply enter your EPP Authorization code along with the domain name you wish
          to transfer in the form above. Once placed our Domain Transfer Specalists will start the process and
          provide you with additional instructions if needed.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ThirdQuestion',
}
</script>
